import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { PageNotFoundComponent } from 'src/app/layout/pages/page-not-found/page-not-found.component';
import { ProvidersComponent } from './providers.component';
import { EditProviderComponent } from './edit-provider/edit-provider.component'
import { AllProvidersComponent } from './all-providers/all-providers.component'
import { AddProviderComponent } from './add-provider/add-provider.component'

import { RetailerPricelistComponent } from './manage-commission/retailer-pricelist/retailer-pricelist.component';
import { PricelistComponent } from './manage-commission/retailer-pricelist/pricelist/pricelist.component';
import { CreatePricelistComponent } from './manage-commission/retailer-pricelist/create-pricelist/create-pricelist.component';
import { BulkUpdatePricelistComponent } from './manage-commission/retailer-pricelist/bulk-update-pricelist/bulk-update-pricelist.component';
import { UpdatePricelistSmartComponent } from './manage-commission/retailer-pricelist/update-pricelist/update-pricelist-smart.component';
import { RetailerImportComponent } from './manage-commission/retailer-pricelist/retailer-import/retailer-import.component';



import { SalesPricelistComponent } from './manage-commission/sales-pricelist/sales-pricelist.component';
import { SalesrepsPricelistComponent } from './manage-commission/sales-pricelist/salesreps-pricelist/salesreps-pricelist.component';
import { SalesrepsBulkUpdatePricelistComponent } from './manage-commission/sales-pricelist/salesreps-bulk-update-pricelist/salesreps-bulk-update-pricelist.component';
import { SalesrepsCreatePricelistComponent } from './manage-commission/sales-pricelist/salesreps-create-pricelist/salesreps-create-pricelist.component';
import { SalesrepsUpdatePricelistComponent } from './manage-commission/sales-pricelist/salesreps-update-pricelist/salesreps-update-pricelist.component';
import { SalesrepsUpdatePricelistSmartComponent } from './manage-commission/sales-pricelist/salesreps-update-pricelist/salesreps-update-pricelist-smart.component';
import { SalesrepsImportComponent } from './manage-commission/sales-pricelist/salesreps-import/salesreps-import.component';
import { MapPricelistComponent } from './map-pricelist/map-pricelist.component';
import { MapPricelistSmartComponent } from './map-pricelist/map-pricelist-smart.component';
import { AllPricelistsComponent } from './update-pricelist/all-pricelists/all-pricelists.component';
import { UpdatePricelistsComponent } from './update-pricelist/update-pricelists/update-pricelists.component';
import { UpdateAllPricelistComponent } from './update-pricelist/update-pricelist.component';
import { ConsumerPricelistComponent } from './manage-commission/consumer-pricelist/consumer-pricelist.component';
import { ConsumerAllPricelistComponent } from './manage-commission/consumer-pricelist/consumer-all-pricelist/consumer-all-pricelist.component';
import { ConsumerImportComponent } from './manage-commission/consumer-pricelist/consumer-import/consumer-import.component';
import { UpdateConsumerPricelistSmartComponent } from './manage-commission/consumer-pricelist/consumer-update-pricelist/consumer-update-pricelist-smart.component';

export const providersRoutes: Routes = [
  {
    path: 'editprovider/:id', component: EditProviderComponent
  },
  {
    path: 'allproviders', component: AllProvidersComponent
  },
  {
    path: 'addprovider', component: AddProviderComponent
  },
  {
    path: 'pricelistmapping', component: MapPricelistSmartComponent
  },
  {
    path: 'retailer', component: RetailerPricelistComponent,
    children: [
      {
        path: 'pricelist', component: PricelistComponent,
      },
      {
        path: 'create', component: CreatePricelistComponent

      },
      {
        path: 'bulkupdate', component: BulkUpdatePricelistComponent

      },
      {
        path: 'update-product/:id', component: UpdatePricelistSmartComponent
      },
      {
        path: 'import', component: RetailerImportComponent
      }

    ]
  },
  {
    path: 'consumer', component: ConsumerPricelistComponent,
    children: [
      {
        path: 'pricelist', component: ConsumerAllPricelistComponent
      },
      {
        path: 'update-product/:id', component: UpdateConsumerPricelistSmartComponent
      },
      {
        path: 'import', component: ConsumerImportComponent
      }

    ]
  },
  {
    path: 'salesreps', component: SalesPricelistComponent,
    children: [
      {
        path: 'pricelist', component: SalesrepsPricelistComponent,
      },
      {
        path: 'create', component: SalesrepsCreatePricelistComponent

      },
      {
        path: 'bulkupdate', component: SalesrepsBulkUpdatePricelistComponent

      },
      {
        path: 'update-product/:id', component: SalesrepsUpdatePricelistSmartComponent
      },
      {
        path: 'import', component: SalesrepsImportComponent
      }
    ]
  },
  {
    path: 'update-pricelist', component: UpdateAllPricelistComponent,
    children: [
      {
        path: 'all-pricelists', component: AllPricelistsComponent,
      },
      {
        path: 'update-pricelist', component: UpdatePricelistsComponent,
      },
      {
        path: 'update-pricelist/:id', component: UpdatePricelistsComponent,
      },
      { 
        path: '', redirectTo: 'all-pricelists',pathMatch: 'full'
      }
    ]
  },

  {
    path: '', redirectTo: 'allproviders', pathMatch: "full"
  },
  {
    path: '**', component: PageNotFoundComponent
  }
]

@NgModule({
  imports: [RouterModule.forChild(providersRoutes)],
  exports: [RouterModule]
})
export class ProviderRoutingModule { }
